import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {app} from '@microsoft/teams-js';
import {LearnerRessource} from '../../../../../micromate-learn-lib/src/lib/services/rest/learner-ressource.service';
import {BrandingService} from '../../../../../micromate-learn-lib/src/lib/services/branding/branding.service';
import {Translation} from '../../../../../micromate-learn-lib/src/lib/services/Translation';

@Injectable({
    providedIn: 'root'
})
export class ProfileLearnerOrganizationService {

    constructor(private learnerService: LearnerRessource,
                private brandingService: BrandingService,
                private translate: TranslateService) {
    }

    // Resolves to false when the learner does not exist yet, so the tab can show the missing learner state instead of crashing.
    public async applyLearnerOrganizationBranding(msteamsId: string, teamsContext: app.Context): Promise<boolean> {
        try {
            const learnerOrganization = await this.learnerService.getLearnerOrganization(msteamsId, teamsContext);
            this.brandingService.setBrandingManually(learnerOrganization.organizationId);
            return true;
        } catch (error) {
            if (!LearnerRessource.isLearnerMissing(error)) {
                throw error;
            }
            // Without a learner there is no learner language or organization, so fall back to the Teams locale and the default branding.
            this.brandingService.setBrandingManually(undefined);
            this.translate.use(new Translation().getTranslationLanguage(teamsContext.app.locale));
            return false;
        }
    }
}
